import React from "react";
import { EvtSectionHeader } from "components/header";
import QueryError from "components/query-error";

export const DASHBOARD_STATS_GRID_CLASS =
  "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 px-4 gap-4 md:px-6";

/**
 * Bordered group wrapping dashboard stat sub-sections. A shared control (e.g.
 * the date filter) sits on the top border, fieldset/legend style; its
 * bg-background masks the line behind it so the border appears broken there.
 */
export const DashboardStatsGroup = ({
  action,
  children,
  label = "Dashboard metrics",
}) => (
  <div className="px-4 md:px-6 pt-8">
    <section aria-label={label} className="relative rounded-xl border pb-6">
      {action && (
        <div className="absolute top-0 right-4 md:right-6 z-10 -translate-y-1/2 bg-background px-2">
          {action}
        </div>
      )}
      {children}
    </section>
  </div>
);

/** Titled sub-section inside a DashboardStatsGroup; children render in the stats grid. */
export const DashboardStatsSubSection = ({ title, children }) => (
  <div>
    {/* Transparent so the header's square bg doesn't paint over the group's
        rounded border corners. `!` (Tailwind v4) beats the built-in bg-background. */}
    <EvtSectionHeader title={title} className="bg-transparent!" />
    <div className={`${DASHBOARD_STATS_GRID_CLASS} mt-2.5`}>{children}</div>
  </div>
);

/** Sub-section showing the standard metrics load error instead of cards. */
export const DashboardStatsErrorSubSection = ({ title, onRetry }) => (
  <div>
    <EvtSectionHeader title={title} className="bg-transparent!" />
    <div className="px-4 md:px-6 mt-2.5">
      <QueryError message="Failed to load dashboard metrics." onRetry={onRetry} />
    </div>
  </div>
);
